export default __webpack_public_path__ + "static/media/whyLocalMattersImage.b0be20e1.png";